// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_011dbe', '__sanomatSans_Fallback_011dbe'"},"className":"__className_011dbe","variable":"__variable_011dbe"};